// extracted by mini-css-extract-plugin
export var stat = "stat-module--stat--3MW7w";
export var image = "stat-module--image--38u49";
export var value = "stat-module--value--2pWRW";
export var label = "stat-module--label--eE8JW";